<template>
  <div>
    <div class="box2">
      <div class="gcjy">
        <div class="on_flex">
          <div class="common_box_tit">
            <div>工程交易</div>
            <div class="bom_line"></div>
          </div>
          <div class="tab_tit">
            <div
                v-for="(it, i) in tabList"
                :key="i"
                :class="current == i ? 'selected' : 'noSelected'"
                @click="getTab(i)"
                @mouseover="getTab(i)"
            >
              {{ it.name }}
            </div>
          </div>
          <div></div>
        </div>
        <div class="cell_box">
          <div v-if="newList.length > 0">
            <div
                v-for="(it, i) in newList"
                :key="i"
                class="cell_list"
                @click="goDetail(it.id)"
            >
              <div class="tag_line"></div>
              <div class="cell_con">
                <div class="title">{{ it.title }}</div>
                <!-- <div>{{it.description}}</div> -->
              </div>
            </div>
            <div
                class="common_more"
                style="float: right; margin-top: 10px"
                @click="goDetail()"
            >
              <span>更多</span>
              <span class="iconfont icon-gengduo"></span>
            </div>
          </div>
          <div
              v-if="newList.length == 0"
              class="common_no_more"
              style="height: 280px"
          >
            暂无内容~
          </div>
        </div>
      </div>
      <div class="kjrk">
        <div class="common_box_tit">
          <div>快捷入口</div>
          <div class="bom_line"></div>
        </div>
        <div class="kjrk_cell">
          <div
              class="item3"
              @click="goUrl({ url: 'login',isOut: false,})"
          >
            <span class="iconfont icon-login"></span>
            <span>登录入口</span>
          </div>
          <div
              class="item2"
              @click="goUrl({ url: 'member',isOut: false,subName: '在线申请会员'})"
          >
            <span class="iconfont icon-shenqing"></span>
            <span>申请入会</span>
          </div>
          <div
              class="item1"
              @click="goUrl({ url: 'people',isOut: false,})"
          >
            <img :src="require('@/assets/images/home/zscx.png')" class="iconfont "></img>
            <span>证书查询</span>
          </div>
          <div
              class="item4"
              @click="goUrl({ url: 'industryCredit',isOut: false,})"
          >
            <span class="iconfont icon-pingjia"></span>
            <span>信用评价结果查询</span>
          </div>
          <div
              class="item5"
              @click="goUrl({ url: 'https://www.dcysjy.com/pms/',isOut: true,})"
          >
            <img :src="require('@/assets/images/home/zjk.png')" class="iconfont "></img>
            <span>多彩贵州综合专家库</span>
          </div>
          <div
              class="item5"
              @click="goUrl({ url: 'https://www.dcysjy.com/',isOut: true,})"
          >
            <img :src="require('@/assets/images/home/jypt.png')" class="iconimg"></img>
            <span>多彩贵州要素交易平台</span>
          </div>
        </div>
      </div>
    </div>
    <div class="bom_box">
      <div class="itme1" @click="goLink('http://61.243.11.189:8099/biding-pc/')">
        <span class="iconfont icon-dengji"></span>
        <span>贵州省工程建设项目招标代理机构管理登记</span>
      </div>
      <div class="itme1" @click="goLink('https://jzsc.mohurd.gov.cn/data/company/bidAgent')">
        <span class="iconfont icon-kefu"></span>
        <span>全国建筑市场监管公共服务平台</span>
      </div>
      <div class="itme1" @click="goUrl({ url: 'download',isOut: false,})">
        <img :src="require('@/assets/images/home/zyxz.png')" class="iconfont "></img>
        <span>资源下载</span>
      </div>
      <div class="itme1" @click="goUrl({ url: 'FAQ',isOut: false,})">
        <img :src="require('@/assets/images/home/zscx.png')" class="iconfont "></img>
        <span>常见问题</span>
      </div>
    </div>
  </div>
</template>
<script>
import {getArticleDes, getLinks} from "@/api/home/index";

export default {
  props: {
    isBlue: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      current: 0,
      tabList: [
        {name: "招标公告", catid: "302"},
        {name: "澄清与修改公告", catid: "304"},
        {name: "中标结果公示", catid: "303"},
        // {name: '中标候选人公公示', catid: '322'},
        // {name: '资审公告', catid: '323'},
      ],
      newList: [],

    };
  },
  mounted() {
    let catid = this.tabList[this.current].catid;
    this.getArticleDes(catid);
  },
  methods: {
    getArticleDes(catid) {
      getArticleDes({catid, pageNo: 1, pageSize: 4}).then((res) => {
        if (res.code == 200 || res.code == 0) {
          this.newList = res.result.records;
        }
      });
    },
    getTab(e) {
      this.current = e;
      let catid = this.tabList[this.current].catid;
      this.getArticleDes(catid);
    },
    goUrl(it) {
      if (it.url) {
        if (it.isOut) {
          window.open(it.url, "_blank");
        } else {
          let query = {};
          if (it.subName) {
            query.name = encodeURIComponent(it.subName);
          }
          this.$router.push({
            name: it.url,
            query: query,
          });
        }
      } else {
        this.$Message.warning("此功能暂未开放！");
      }
    },
    goDetail(id) {
      // if(this.current==2){
      // 	if(id){
      // 		this.$router.push({
      // 			name: 'news_detail',
      // 			query: {
      // 				id:id
      // 			},
      // 			params:{
      // 				locationList:encodeURIComponent(JSON.stringify(['首页','违法违规信息']))
      // 			}
      // 		});
      // 	}else{
      // 		this.$router.push({
      // 			name: 'news',
      // 			query: {
      // 				catid: 305
      // 			}
      // 		});
      // 	}
      // }else{
      let url = "";
      let catid = this.tabList[this.current].catid;
      let query = {};
      let params = {};
      if (id) {
        url = "news_detail";
        query = {
          id,
        };
        params = {
          locationList: encodeURIComponent(
              JSON.stringify(["工程交易", this.tabList[this.current].name]),
          ),
        };
      } else {
        url = "engineering";
        query = {
          name: this.tabList[this.current].name,
        };
      }
      this.$router.push({
        name: url,
        query: query,
        params: params,
      });
      // }
    },
    goLink(url) {
      window.open(url, "_blank");
    },
  },
};
</script>
<style lang="scss" scoped>
.iconimg {
  margin-right: 10px;
  width: 25px;
  height: 25px;
}

.box2 {
  display: flex;

  .gcjy {
    flex: 1;
    width: 55%;
    padding-right: 70px;

    .tab_tit {
      display: flex;
      justify-content: space-between;
      font-size: 17px;
      white-space: nowrap;
      width: 60%;

      div {
        padding: 5px 10px;
        cursor: pointer;
      }

      .selected {
        border: none;
        color: #fff;
        background: linear-gradient(270deg, #2d85e2 2%, #5b43df 100%);
      }

      .noSelected:hover {
        color: #2d85e2;
      }
    }

    .cell_box {
      width: 100%;
      // height: 280px;
      // overflow-y: scroll;
      margin-top: 15px;

      .cell_list {
        display: flex;
        align-items: center;
        border-bottom: 1px solid #eee;
        // padding-bottom: 10px;
        // margin-top: 30px;
        padding: 10px 5px;
        margin-top: 20px;
        cursor: pointer;

        .tag_line {
          margin-right: 20px;
          width: 3px;
          height: 19px;
          background: linear-gradient(270deg, #2d85e2 2%, #5b43df 100%);
        }

        .cell_con {
          width: 100%;
        }

        div {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          font-size: 14px;
        }

        .title {
          font-size: 15px;
        }
      }

      .cell_list:hover {
        background-color: #eee;
      }
    }
  }

  .kjrk {
    width: 45%;

    .kjrk_cell {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      margin-top: 5px;

      > div {
        display: flex;
        padding-left: 15px;
        align-items: center;
        width: 47%;
        min-width: 165px;
        height: 80px;
        border-radius: 8px;
        font-size: 16px;
        color: #fff;
        margin: 10px 0;
        white-space: nowrap;
        cursor: pointer;
        transition: all 0.22s ease-in;
        -webkit-transition: all 0.22s ease-in;
        -moz-transition: all 0.22s ease-in;
        -o-transition: all 0.22s ease-in;

        .iconfont {
          margin-right: 10px;
          font-size: 25px;
        }
      }

      > div:hover {
        transform: scale(1.08);
      }

      .item1 {
        background: linear-gradient(180deg, #6d8be7 2%, #4160c1 100%);
        //justify-content: center;
      }

      .item2 {
        background: linear-gradient(180deg, #ffc868 0%, #f68915 100%);
      }

      .item3 {
        background: linear-gradient(180deg, #e24069 5%, #ae2626 100%);
      }

      .item4 {
        background: linear-gradient(180deg, #8ce0fc 3%, #316fe7 99%);
      }

      .item5 {
        background: linear-gradient(180deg, #8ce0fc 0%, #26af74 98%);
      }
    }
  }
}

.bom_box {
  display: flex;
  justify-content: space-between;
  margin-top: 30px;
  font-size: 16px;

  > div {
    white-space: nowrap;
    color: #fff;
    padding: 20px 10px;
    border-radius: 8px;
    background: linear-gradient(270deg, #2d85e2 2%, #5b43df 100%);
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 20px;
    cursor: pointer;
    transition: all 0.22s ease-in;
    -webkit-transition: all 0.22s ease-in;
    -moz-transition: all 0.22s ease-in;
    -o-transition: all 0.22s ease-in;

    .iconfont {
      margin-right: 10px;
      font-size: 25px;
    }
  }

  > div:hover {
    box-shadow: 8px 8px 10px 0 rgba(153, 153, 153, 0.5);
  }

  > div:first-child {
    width: 30%;
  }

  > div:nth-child(2) {
    width: 25%;
  }
  > div:nth-child(3) {
    width: 20%;
  }
  > div:last-child {
    width: 20%;
  }
}

/* 手机 */
@media only screen and (max-width: 800px) {
  .box2 {
    display: inline-block;
    width: 100%;

    .on_flex {
      // display: inline-block;
    }

    .gcjy {
      width: 100%;
      padding-right: 0;
      margin-bottom: 70px;

      .tab_tit {
        width: auto;
        margin-top: 10px;

        > div {
          padding: 5px 8px;
        }
      }
    }

    .kjrk {
      width: 100%;
    }

    .cell_list {
      margin-top: 0 !important;
      padding: 15px 5px !important;
    }
  }
  .bom_box {
    flex-direction: column;

    > div:first-child {
      width: 100%;
    }

    > div:nth-child(2) {
      width: 100%;
    }

    > div:last-child {
      width: 100%;
    }
  }
}
</style>
